module.exports = __webpack_public_path__ + "img/convert-bomb-logo-text.2e44bf8d.svg";